<template>
    <div class="ProcessSubview">
        <QCard
            bordered
            class="ProcessSubviewCard"
        >
            <QCardSection>
                <TracesSection
                    ref="tracesSection"
                    :key="reloadKey"
                    :processId="processId"
                    :filteredTraces="filteredTraces"
                    :attributes="attributes"
                />
            </QCardSection>
        </QCard>
    </div>
</template>

<script>
import VueTypes from 'vue-types'
import TracesSection from '../Traces/TracesSection.vue'

export default {
    name: 'TracesSubview',
    components: { TracesSection },
    props: {
        processId: VueTypes.any,
        attributes: VueTypes.array,
        infoFiltered: VueTypes.object,
    },
    data() {
        return {
            reloadKey: 0,
        }
    },
    computed: {
        filteredTraces() {
            return this.infoFiltered?.cases || 0
        },
    },
    methods: {
        reloadCurrentView() {
            this.reloadKey += 1
        },

        applyTracesSearch({ search } = {}) {
            this.$refs.tracesSection?.applySearch?.(search || '')
        },
        openTracesExport() {
            this.$refs.tracesSection?.openExport?.()
        },
        createTracesDataset({ name } = {}) {
            if (!name) return
            this.$refs.tracesSection?.generateDataset?.(name)
        },
    },
}
</script>

<style scoped lang="scss">
.ProcessSubview {
    height: 100%;
}

.ProcessSubviewCard {
    height: 100%;
}
</style>
